import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./QRCodePanel.css";

export const buildHashUrl = (path) => {
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${window.location.pathname}#${path}`;
};

export default function QRCodePanel({ title = "Scan QR", value, note }) {
  if (!value) return null;

  return (
    <div className="qr-panel">
      <div className="qr-box">
        <QRCodeCanvas value={value} size={116} includeMargin />
      </div>
      <div className="qr-copy">
        <strong>{title}</strong>
        {note && <span>{note}</span>}
        <a href={value} target="_blank" rel="noreferrer">
          Open link
        </a>
      </div>
    </div>
  );
}
